<script>
export let url_params;
export let free_agents; // base :)
let active_free_agents = free_agents;


import FreeAgentThumb from 'components/views/my/free-agents/thumbs/FreeAgent.svelte';
import ErrorPanelBlock from 'components/elements/ErrorPanelBlock.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';
// import ParentInfoModal from './ParentInfoModal.svelte';
// on click --- ?
// import tippy from 'sveltejs-tippy';


let tmp_free_agents;



function filterPosition(free_agent) {
	return ((free_agent.position).toLowerCase().includes((url_params.position).toLowerCase()));
}


function filterBirthYear(free_agent) {
	return (String(free_agent.player_date_of_birth).substring(0,4) === (url_params.birth_year).toLowerCase());
}


function filterLevel(free_agent) {
	return ((free_agent.current_team_level).toLowerCase() === (url_params.level).toLowerCase());
}


function filterProvince(free_agent) {
	return ((free_agent.province).toLowerCase() === (url_params.province).toLowerCase());
}



$: {

	// active_free_agents = free_agents;

	console.log(url_params);

	tmp_free_agents = free_agents;

	if (!!url_params['position']) {
		// filters
		tmp_free_agents = tmp_free_agents.filter(filterPosition);
	}

	if (!!url_params['birth_year']) {
		// filters (acreb.ca)
		tmp_free_agents = tmp_free_agents.filter(filterBirthYear);
	}

	if (!!url_params['level']) {
		// filters (acreb.ca)
		tmp_free_agents = tmp_free_agents.filter(filterLevel);
	}

	if (!!url_params['province']) {
		// filters (acreb.ca)
		tmp_free_agents = tmp_free_agents.filter(filterProvince);
	}

	active_free_agents = tmp_free_agents;


	console.log(active_free_agents);
	
}




</script>



<style>

#parents-table {

}

</style>



<div class="panel" id="parents-table">

	<div class="panel-heading">

		<div class="columns is-variable is-2 is-mobile">

			<div class="column is-3-desktop is-4-touch">
				<span>Name</span>
			</div>

			<div class="column is-2-desktop is-3-touch">
				<span>Position</span>
			</div>

			<div class="column is-1-desktop is-2-touch">
				<span>Birth Year</span>
			</div>

			<div class="column is-2-desktop is-3-touch">
				<span>Last Team Level</span>
			</div>

			<div class="column is-2-desktop is-hidden-touch">
				<span>City</span>
			</div>

			<div class="column is-2-desktop is-hidden-touch">
				<span>Province</span>
			</div>

		</div>

	</div>

	{#each active_free_agents as free_agent}
		<!-- {free_agent.position} -->
		<FreeAgentThumb {free_agent} />
	{/each}

</div>


{#if active_free_agents.length === 0}
	<MsgCard msg_show={true} msg_text={'No free agents found!'} msg_type={'error'} msg_forever={true} />
	<!-- <ErrorPanelBlock msg={'No registrations yet.'} /> -->
{/if}


